module.exports = __webpack_public_path__ + "img/0.c680d12c.jpg";